export default {
  // --- Common ---
  'common.loading': 'Chargement…',
  'common.loadingError': 'Erreur de chargement.',

  // --- Error fallback (main.js) ---
  'error.title': 'Erreur',
  'error.body': 'Une erreur est survenue. Recharge la page ou contacte-nous.',

  // --- Home ---
  'home.eyebrow': 'Census · par Doodive',
  'home.zone_selector.title': 'Choisissez votre zone de plongée',
  'home.zone_selector.species_count': '{count} espèce | {count} espèces',

  // --- Zones maritimes ---
  'zones.mediterranean': 'Mer Méditerranée',
  'zones.red_sea': 'Mer Rouge',


  'home.title.pre': 'Recensement collaboratif de la ',
  'home.title.em': 'faune sous-marine',
  'home.lead': 'Plongeurs, snorkeleurs : enregistrez les espèces aperçues pendant vos sorties. Contribuez à une base de données ouverte aux biologistes marins du monde entier.',
  'home.cta.start': 'Commencer à recenser',
  'home.cta.catalog': 'Voir le catalogue',
  'home.discover.title': 'Découvrir',
  'home.status.loading': 'Connexion en cours…',
  'home.status.ok': 'Base de données connectée',
  'home.status.offline': 'Hors ligne (configurer .env.local)',
  'home.footer': '© Doodive · Phase 1 · Catalogue Méditerranée',

  // --- Observations iNaturalist ---
  'detail.fact.observations': 'Observations',
  'detail.fact.observations.value': '{count} observations',

  // --- Espèce invasive ---
  'species.invasive': 'Espèce invasive',

  // --- Zone de profondeur ---
  'detail.fact.typical_depth': 'Zone',
  'typical_depth.coastal': 'Côtier',
  'typical_depth.midwater': 'Mi-eau',
  'typical_depth.deep': 'Profond',

  // --- Catégories taxonomiques ---
  'category.all':         'Tous',
  'category.fish':        '🐠 Poissons',
  'category.mollusk':     '🐙 Mollusques',
  'category.coral':       '🪸 Coraux',
  'category.crustacean':  '🦀 Crustacés',
  'category.echinoderm':  '🌟 Échinodermes',
  'category.plant':       '🌿 Algues & Plantes',
  'category.mammal':      '🐬 Mammifères marins',
  'category.turtle':      '🐢 Tortues',
  'category.other':       '· Autres',

  // --- Species list ---
  'list.eyebrow': 'Catalogue',
  'list.eyebrow_zone': 'Catalogue · {zone}',
  'list.title': 'Espèces à reconnaître.',
  'list.lead': 'Référence photographique pour vos plongées. Photos sous licence Creative Commons via iNaturalist.',
  'list.search.placeholder': 'Rechercher (girelle, mérou, sparus aurata…)',
  'list.danger.toggle': 'Espèces à éviter',
  'list.empty': 'Aucune espèce ne correspond.',
  'list.count': '{count} espèce | {count} espèces',
  'list.danger.tooltip': 'Niveau de danger : {level}/5',

  // --- Species detail ---
  'detail.notFound.title': 'Espèce introuvable',
  'detail.notFound.body': `Cette fiche n'existe pas ou a été supprimée.`,
  'detail.notFound.back': '← Retour au catalogue',
  'detail.nav.back': '← Catalogue',
  'detail.nav.back_swipe': '← Recenser',
  'detail.fallback.taxClass': 'Espèce marine',
  'detail.gallery.aria': 'Voir la photo {n} sur {total}',
  'detail.photo.credit': 'Photo :',
  'detail.wikipedia.source': 'Source :',
  'detail.wikipedia.label': 'Wikipédia',
  'detail.wikipedia.license': '· Licence',
  'detail.fact.size': 'Taille max.',
  'detail.fact.depth': 'Profondeur',
  'detail.fact.danger': 'Dangerosité',
  'detail.fact.iucn': 'Statut UICN',
  'detail.danger.eyebrow': '⚠ À savoir',
  'detail.taxonomy.eyebrow': 'Classification',
  'detail.section.habitat': 'Habitat',
  'detail.section.diet': 'Régime alimentaire',
  'detail.section.reproduction': 'Reproduction',
  'detail.external.eyebrow': 'Pour aller plus loin',

  // --- Danger levels ---
  'danger.0': 'Inoffensif',
  'danger.1': 'Précaution',
  'danger.2': 'Risque modéré',
  'danger.3': 'Dangereux',
  'danger.4': 'Très dangereux',
  'danger.5': 'Extrême',

  // --- IUCN ---
  'iucn.LC': 'Préoccupation mineure',
  'iucn.NT': 'Quasi menacée',
  'iucn.VU': 'Vulnérable',
  'iucn.EN': 'En danger',
  'iucn.CR': 'En danger critique',
  'iucn.EW': `Éteinte à l'état sauvage`,
  'iucn.EX': 'Éteinte',
  'iucn.DD': 'Données insuffisantes',

  // --- Depth ---
  'depth.upTo': `jusqu'à {max} m`,
  'depth.from': 'dès {min} m',

  // --- Swipe ---
  'swipe.reset.label': 'Recommencer',
  'swipe.btn.no.label': 'Pas vu',
  'swipe.btn.no.text': 'Pas vue',
  'swipe.btn.no.title': 'Pas vu (←)',
  'swipe.btn.doubt.label': 'Je doute',
  'swipe.btn.doubt.text': 'Doute',
  'swipe.btn.doubt.title': 'Je doute (espace)',
  'swipe.btn.yes.label': 'Vu',
  'swipe.btn.yes.text': 'Vue',
  'swipe.btn.yes.title': 'Vu (→)',
  'swipe.progress.total': '{count} espèce | {count} espèces',
  'swipe.progress.seenLabel': 'vue | vues',
  'swipe.progress.remaining': '{count} restante | {count} restantes',
  'swipe.empty.eyebrow': 'Bravo',
  'swipe.empty.title': 'Tu as parcouru toutes les espèces.',
  'swipe.empty.title_filtered': 'Tu as parcouru tous les {category}.',
  'swipe.empty.seen': '{count} vue | {count} vues',
  'swipe.empty.doubt': '{count} avec doute',
  'swipe.empty.skipped': '{count} pas vue | {count} pas vues',
  'swipe.empty.catalog': 'Voir le catalogue',
  'swipe.empty.restart': 'Recommencer',
  'swipe.confirm.reset': 'Tout réinitialiser ?',
  'swipe.confirm.fullReset': 'Recommencer depuis le début ? Tes observations actuelles seront perdues.',
  'swipe.badge.yes': 'VU',
  'swipe.badge.no': 'PAS VU',
  'swipe.card.danger': 'Danger {level}/5',
  'swipe.card.more': 'Voir la fiche →',

  // --- Not found ---
  'notFound.eyebrow': 'Erreur 404',
  'notFound.title': 'Page introuvable',
  'notFound.body': `Cette page n'existe pas ou plus.`,
  'notFound.back': `Retour à l'accueil`,

  // --- Navigation globale ---
  'nav.logo': 'Census',
  'header.baseline.line1': 'Recensement collaboratif',
  'header.baseline.line2': `de la faune sous-marine`,
  'nav.back.home': 'Accueil',
  'nav.back.catalog': 'Catalogue',
  'nav.back.swipe': 'Recenser',
  'nav.back.generic': 'Retour',
  'nav.back.species': '{name}',
  'nav.back.results': 'Résultats',
  'nav.back.region': '{name}',
  'nav.back_home': '← Accueil',
  'nav.back_home.aria': `Retour à l'accueil`,
  'nav.home': 'Accueil',
  'nav.catalog': 'Catalogue',
  'nav.survey': 'Recenser',
  'nav.help': 'Aide',
  'nav.menu.open': 'Ouvrir le menu',
  'nav.menu.close': 'Fermer le menu',

  // --- Page Aide ---
  'help.eyebrow': `Guide d'utilisation`,
  'help.title': 'Comment ça marche ?',
  'help.back': '← Accueil',
  'help.s1.title': 'Le recensement collaboratif',
  'help.s1.body': `Census by Doodive est un projet de science participative. Chaque plongée ou sortie snorkeling est une occasion de contribuer à la connaissance de la biodiversité marine méditerranéenne. Vos observations alimentent une base de données ouverte, consultable par les biologistes et les associations de protection des océans.`,
  'help.s2.title': 'Le swipe Vu / Pas vu',
  'help.s2.body': `Sur la page Recenser, les fiches espèces défilent une par une. Balayez vers la droite (ou appuyez le bouton VUE 👁 à droite) si vous avez déjà aperçu cette espèce. Balayez vers la gauche (ou appuyez PAS VUE 👁‍🗨 à gauche) si vous ne l'avez jamais vue. Le bouton ? au centre permet de marquer un doute. Vos réponses sont enregistrées localement sur votre appareil.`,
  'help.s3.title': 'Données et espèces',
  'help.s3.body': `Vos données restent sur votre appareil — aucun compte n'est nécessaire pour contribuer. Les photos sont issues d'iNaturalist sous licence Creative Commons ; respectez les crédits des photographes. Sur le terrain, observez les espèces sans les déranger : un bon recensement commence par le respect du milieu marin.`,

  // --- Snackbar ---
  'snackbar.undo': 'ANNULER',
  'swipe.snackbar.marked': `{name} marqué·e « {choice} »`,
  'swipe.snackbar.choice.seen': 'vue',
  'swipe.snackbar.choice.skipped': 'pas vue',
  'swipe.snackbar.choice.doubt': 'doute',

  // --- Footer ---
  'footer.copyright': '© {year} census.doodive.com',

  // --- Profile card ---
  'profile.anonymous': 'Plongeur anonyme',
  'profile.level.snorkeler': 'Apnéiste / PMT',
  'profile.level.open_water': 'Plongeur Open Water',
  'profile.level.advanced': 'Plongeur Avancé',
  'profile.level.divemaster': 'Divemaster',
  'profile.level.instructor': 'Instructeur',
  'profile.level.biologist': 'Biologiste marin',
  'profile.stats.seen': '{count} espèce vue | {count} espèces vues',
  'profile.stats.doubt': '{count} doute | {count} doutes',
  'profile.last_sighting': 'Dernier recensement',
  'profile.no_sighting': `Aucun recensement pour l'instant`,
  'profile.since': 'Membre depuis {date}',
};
